<template>
  <div>
    <div class="sidebar sidebar-end" :class="[isSidebarActive ? 'sidebar-active' : '']">
      <div class="sidebar-content">
        <div class="sidebar-header">
          <div class="text-poppins fw-500">{{ gradient.name }}</div>
          <button class="btn btn-link btn-sm ripple ripple-primary m-0" @click="sidebarToggle()">
            <i class="material-icons-outlined">close</i>
          </button>
        </div>
        <div class="sidebar-body">
          <!-- PILLS BUTTONS -->
          <ul class="nav nav-pills pills-container mb-3" id="pills-tab" role="tablist">
            <li class="nav-item d-flex flex-grow-1" role="presentation">
              <button class="nav-link nav-primary flex-grow-1 subtitle-1 border-radius-8 ripple active"
                      id="pills-android-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-android"
                      type="button" role="tab" aria-controls="pills-android" aria-selected="true">Android
              </button>
            </li>
            <li class="nav-item d-flex flex-grow-1" role="presentation">
              <button class="nav-link nav-primary flex-grow-1 subtitle-1 border-radius-8 ripple"
                      id="pills-flutter-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-flutter"
                      type="button" role="tab" aria-controls="pills-flutter" aria-selected="false">Flutter
              </button>
            </li>
          </ul>
          <!-- TAB CONTENT -->
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="pills-android" role="tabpanel"
                 aria-labelledby="pills-android-tab">
              <div class="subtitle-1 mt-4">Android color codes</div>
              <hr>
              <code class="text-lowercase">
                &lt;color name="{{ gradient.name }}_1"&gt;{{ gradient.color1 }}&lt;/color&gt;
              </code>
              <hr>
              <code class="text-lowercase">
                &lt;color name="{{ gradient.name }}_2"&gt;{{ gradient.color2 }}&lt;/color&gt;
              </code>
              <hr>
              <code class="text-lowercase">
                <div v-if="gradient.color3">
                  &lt;color name="{{ gradient.name }}_3"&gt;{{ gradient.color3 }}&lt;/color&gt;
                </div>
              </code>
            </div>
            <div class="tab-pane fade" id="pills-flutter" role="tabpanel" aria-labelledby="pills-flutter-tab">
              <div class="subtitle-1 mt-4">Flutter color codes</div>
              <hr>
              <code>
                const {{ gradient.name }}1 = const Color(0xFF<span v-if="gradient.color1"
                                                                   v-text="sliceFlutterColor1()"></span>);
              </code>
              <hr>
              <code>
                const {{ gradient.name }}2 = const Color(0xFF<span v-if="gradient.color2"
                                                                   v-text="sliceFlutterColor2()"></span>);
              </code>
              <hr>
              <code>
                <div v-if="gradient.color3">
                  const {{ gradient.name }}3 = const Color(0xFF<span v-if="gradient.color3"
                                                                     v-text="sliceFlutterColor3()"></span>);
                </div>
              </code>
            </div>
          </div>

        </div>
        <div class="sidebar-footer">
          <div class="subtitle-2">
            Click the code to copy, and if it doesn't work, just ctrl + c 😀
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarCodesGradient',
  mounted() {
    this.copyCode()
  },
  methods: {
    sliceFlutterColor1() {
      return this.gradient.color1.slice(1)
    },
    sliceFlutterColor2() {
      return this.gradient.color2.slice(1)
    },
    sliceFlutterColor3() {
      return this.gradient.color3.slice(1)
    },
    copyCode() {
      const aioAndroid = document.querySelectorAll('code')
      aioAndroid.forEach(code => {
        code.addEventListener('click', () => {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(code);
          selection.removeAllRanges();
          selection.addRange(range);

          try {
            document.execCommand('copy');
            selection.removeAllRanges();

            const original = code.textContent;
            code.textContent = 'Code copied!';
            code.classList.add('text-success');
            this.$swal({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              icon: 'success',
              title: 'Code copied!',
            });

            setTimeout(() => {
              code.textContent = original;
              code.classList.remove('text-success');
            }, 1200);
          } catch (e) {
            const errorMsg = document.querySelector('.error-msg');
            errorMsg.classList.add('d-block');

            setTimeout(() => {
              errorMsg.classList.remove('d-block');
            }, 1200);
          }
        });
      });
    }
  },
  props: [
    'isSidebarActive',
    'gradient',
    'sidebarToggle'
  ]
}
</script>